import "./App.css";
import Banner from "./components/Banner/Banner";
import ContentBlock from "./components/ContentBlock/ContentBlock";
import Product from "./components/Product/Product";
import TabbedContent from "./components/TabbedContent/TabbedContent";
import contentData from "./data/app";
import "./scss/style.scss";

function App() {
  const data = contentData();
  const dataSections = data[0].data.sections[0].home;
  const { banner, general, products, tabs } = dataSections;

  return (
    <div className="App">
      <main>
        <Banner data={banner} />

        <section>
          <ContentBlock params={general} />
        </section>

        <TabbedContent data={tabs} />

        {products.product.map((product) => {
          const { background, id, productContent, productBanner } = product;

          return (
            <Product
              background={background}
              key={id}
              productContent={productContent}
              productBanner={productBanner}
            />
          );
        })}
      </main>
    </div>
  );
}

export default App;
